import styled from 'styled-components';

export const InfoButton = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;
